import { type LensGroupInfo } from "../../lenses/lens-details/models";
import { type LensConnection } from "../models";

export const LensConnectionConvertor = {
    fromLensGroupInfo({ groupId, scheduleRange, priority, vendorData }: LensGroupInfo): LensConnection {
        return {
            groupId,
            priority,
            scheduleRange,
            vendorData: vendorData.toDataObjects(),
        };
    },
};
